/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /* スクロールイベント間引き */
function throttle(fn, wait, arg) {
  let time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn(arg);
      time = Date.now();
    }
  }
}

/* スクロール時フェードイン */
let ScrollEventFade = function(scrollFadeContents){
  let offset = -150;
  let scrollPositionY = document.documentElement.scrollTop || document.body.scrollTop
  const posheight = window.innerHeight;
  scrollFadeContents.forEach(function(content) {
    const posy = window.pageYOffset + content.getBoundingClientRect().top;
    if(posy - offset < scrollPositionY + posheight) {
      content.classList.add('is-scroll-fade')
    }
  })
}
window.addEventListener('load', () => {
  let scrollFadeContents = document.querySelectorAll('.scroll-fade-contents');
  if(scrollFadeContents.length >= 1){
    window.addEventListener('scroll', throttle(ScrollEventFade, 100, scrollFadeContents));
  }
});

/* スクロール時ヘッダースタイル変更 */
let ScrollEventHeader = function(header){
  let scrollPositionY = document.documentElement.scrollTop || document.body.scrollTop
  // get Drawer__Content
  let DrawerContent = document.querySelector('.Drawer__Content');
  if(header.offsetHeight < scrollPositionY) {
    header.classList.add('is-scrolled')
    if(DrawerContent) {
      DrawerContent.classList.add('is-scrolled')
    }
  } else {
    header.classList.remove('is-scrolled')
    if(DrawerContent) {
      DrawerContent.classList.remove('is-scrolled')
    }
  }
}
window.addEventListener('load', () => {
  let header = document.getElementById('section-header')
  window.addEventListener('scroll', throttle(ScrollEventHeader, 10, header));
});


/*checking mobile device */
let hasTouchScreen = false;
if ("maxTouchPoints" in navigator) {
  hasTouchScreen = navigator.maxTouchPoints > 0;
} else if ("msMaxTouchPoints" in navigator) {
  hasTouchScreen = navigator.msMaxTouchPoints > 0;
} else {
  let mQ = window.matchMedia && matchMedia("(pointer:coarse)");
  if (mQ && mQ.media === "(pointer:coarse)") {
    hasTouchScreen = !!mQ.matches;
  } else if ('orientation' in window) {
    hasTouchScreen = true;
  } else {
    let UA = navigator.userAgent;
    hasTouchScreen = (
      /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
      /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
    );
  }
}

if(!hasTouchScreen) {
  /* image tracking */
  let imageTrackingBgFuncMove = function(event){
    if( window.innerWidth > 640 ){
      //画像中央からの位置を取得
      let hoverX = event.offsetX - event.target.offsetWidth / 2
      let hoverY = event.offsetY - event.target.offsetHeight / 2
      let scale = 1.1
      let weight = 0.5;

      if(this.scale){
        scale = this.scale
      }
      if(this.weight){
        weight = this.weight
      }

      //はみ出ないように移動距離を調整
      let moveX = hoverX*(scale - 1)*weight
      let moveY = hoverY*(scale - 1)*weight

      //1以下は別途調整
      if(scale <= 1) {
        moveX = hoverX*0.1*weight
        moveY = hoverY*0.1*weight
      }
      
      if(this.withSlider) {
        let trackingForFlickity = document.querySelector('.trackingForFlickity .flickity-viewport');
        trackingForFlickity.style.transform = "scale(" + scale + ", " + scale + ")"
        event.target.style.transform = "translate(" + moveX + 'px ,' + moveY + "px)"
      } else {
        event.target.style.transform = "scale(" + scale + ", " + scale + ")" + " translate(" + moveX + 'px ,' + moveY + "px)"
      }
    }
  }

  let imageTrackingBgFuncLeave = function(event){
    event.target.style.transform = "scale(1, 1)" + " translate(0)"
    if(this.withSlider) {
      let trackingForFlickity = document.querySelector('.trackingForFlickity .flickity-viewport');
      trackingForFlickity.style.transform = "scale(1, 1)"
    }
  }

  window.addEventListener('load', () => {
    
    // top backgroundimage
    let imageTrackingBg = document.querySelectorAll('.image-tracking-bg');
    if(imageTrackingBg.length >= 1){
      imageTrackingBg.forEach(function(content) {
        content.addEventListener('mousemove', {
          scale: 1.1,
          weight: 0.5,
          handleEvent: imageTrackingBgFuncMove
      });
        content.addEventListener('mouseleave', imageTrackingBgFuncLeave);
      })
    }

    // product thumbnails
    let imageTrackingSmallimg = document.querySelectorAll('.image-tracking-smallimg');
    if(imageTrackingSmallimg.length >= 1){
      imageTrackingSmallimg.forEach(function(content) {
        content.addEventListener('mousemove', {
          scale: 1.05,
          weight: 4,
          handleEvent: imageTrackingBgFuncMove
      });
        content.addEventListener('mouseleave', imageTrackingBgFuncLeave);
      })
    }

    // product slider
    let imageTrackingProductimg = document.querySelectorAll('.image-tracking-productimg');
    if(imageTrackingProductimg.length >= 1){
      imageTrackingProductimg.forEach(function(content) {
        content.addEventListener('mousemove', {
          scale: 1.03,
          weight: 1.6,
          withSlider: true,
          handleEvent: imageTrackingBgFuncMove
      });
        content.addEventListener('mouseleave', {
          withSlider: true,
          handleEvent: imageTrackingBgFuncLeave
        });
      })
    }

    // top slider
    let imageTrackingTopSliderimg = document.querySelectorAll('.image-tracking-topsliderimg');
    if(imageTrackingTopSliderimg.length >= 1){
      imageTrackingTopSliderimg.forEach(function(content) {
        content.addEventListener('mousemove', {
          scale: 1,
          weight: 0.5,
          withSlider: true,
          handleEvent: imageTrackingBgFuncMove
      });
        content.addEventListener('mouseleave', {
          withSlider: true,
          handleEvent: imageTrackingBgFuncLeave
        });
      })
    }

    // featured product slider
    let imageTrackingFeaturedProductimg = document.querySelectorAll('.image-tracking-featured-productimg');
    if(imageTrackingFeaturedProductimg.length >= 1){
      imageTrackingFeaturedProductimg.forEach(function(content) {
        content.addEventListener('mousemove', {
          scale: 1.03,
          weight: 1.6,
          handleEvent: imageTrackingBgFuncMove
      });
        content.addEventListener('mouseleave', {
          withSlider: true,
          handleEvent: imageTrackingBgFuncLeave
        });
      })
    }
  });
}

